<template>
	<div :id="appointment.appointmentId +'_'+ appointmentStatus.rank"
	     v-bind:class="color"
	     class="w3-panel w3-card-2 w3-round-medium  w3-padding-small"
	     :draggable="!isStatusNoBadge(appointment.status) && !isStatusLeftConsultation(appointment.status) && canForwardPatient()"
	     v-on:dragstart="onDragStart(!isStatusNoBadge(appointment.status) && !isStatusLeftConsultation(appointment.status) && canForwardPatient())"
	     v-on:drop="dropOnCard(isWaiting(appointmentStatus.status), $event)">
		<div class="group-blocks">
			<div v-for="g in groups" :class="appStatus(g)">
				{{ g.shortName }}
			</div>
		</div>
		<div class="w3-cell w3-left w-80pc">
			<div class="w3-col flow-blue-color font-weight-bold ">
				<span>{{ appointment.appointmentTime }} - </span>
				<span class="zero w3-show-inline-block w3-medium">
					<b class="cursor-pointer flow-underline"
					   @click="selectPatient(appointment)">{{ appointment.patientName }}</b>
					<span v-if="device">
							<i class="fa fa-mobile-alt flow-margin-right flow-green-active-color flow-padding-left"
							   :title="$t('loggedIn')"></i>
					</span>
					<span v-if="appointment.ticket">({{ appointment.ticket }})</span>
				</span>
			</div>

			<div class="w3-col">
				<span :title="$t('dob')">{{ dob }}</span>
			</div>

			<div class="w3-col">
				<span v-if="appointment.comment" :title="$t('comments')">{{ appointment.comment }}</span>
				<span v-else :title="$t('comments')">{{ notGiven }}</span>
			</div>

        <div class="w3-col" v-if="isDressing(appointmentStatus.status)">
            <span>{{ getCalledToRoom() }}</span>
        </div>
		</div>


		<div class="w3-container w3-cell w3-large w3-cell-top zero w3-right  w3-center">
			<i v-if="canForwardPatient()"
			   :id="appointment.appointmentId+'_forward'" :title="$t('forward')"
			   @click="forwardPatient"
			   class="fa fa-share flow-green-other-color cursor-pointer"></i><br>
			<div class=" w3-text-deep-orange">
				<i class="fa fa-bullhorn cursor-pointer" :title="$t('callPatientAgain')"
				   v-if="recall"
				   @click.prevent="recallAppointment(appointment.patientId, appointment.appointmentId)"></i><br>
			</div>

			<!--Not available in MI yet, but to be done-->
			<div class="w3-text-red"
			     v-if="appointmentStatus.maxTimeAllowedInMilli && appointmentStatus.maxTimeAllowedInMilli>0">
				<i class="fa fa-clock"></i><br>
				<b class="w3-medium">{{ timeInStatus }}</b>
			</div>
		</div>

		<div class="w3-cell" v-if="nextConsultation">
			<i class="fa fa-sign-in-alt flow-margin-right" :title="$t('nextConsultation')"></i>
			<span :title="$t('nextConsultation')">{{ nextConsultation.physician }}({{ nextConsultation.time }})</span>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import {EventBus} from "@/main";
import PatientStatus from "@/components/common/PatientStatus";
import i18n from "@/lang/lang";

let frc = Vue.prototype.$frc;

export default {
	name: "patientCard",
	components: {PatientStatus},
	props: ['appointment', 'statuses', 'appointmentStatus', 'notify', 'plugin', 'groups'],
	data: function () {
		return {
			notGiven: this.$t("notGiven"),
			checkupStatusInActive: false,
			nextConsultation: undefined,
			otherAppointments: []
		}
	},
	watch: {
		appointment(newval, oldval) {
			if (newval.numOfAppointments !== oldval.numOfAppointments) {
				this.getOtherAppointments();
			}
		}
	},
	mounted() {
		this.getOtherAppointments();
	},
	computed: {
		recall() {
			return this.isStarted(this.appointment.checkups[0].status);
		},
		color() {
			if (this.isDressing(this.appointmentStatus.status)) {
				let currentCheckup = this.getCurrentCheckup();
				if (currentCheckup && !this.isDressing(currentCheckup.type) || currentCheckup.rank !== this.appointmentStatus.rank) {
					return 'flow-gray-bg-color';
				}
			}

			if (this.isStatusNoBadge(this.appointment.status)) {
				return 'flow-gray-bg-color';
			} else if (this.appointment.overstay) {
				return 'w3-pale-red';
			} else if (this.notify) {
				return 'w3-khaki';
			} else if (this.isMinor === 'true') {
				return 'w3-pale-blue';
			} else if (this.checkupStatusInActive) {
				return 'w3-yellow';
			}

			return 'w3-white';
		},
		dob() {
			let res = Vue.getValueForKey(this.appointment.patientProperties.entry, 'birth_date');
			return res ? res : this.notGiven;
		},
		device() {
			return Vue.getValueForKey(this.appointment.patientProperties.entry, 'device');

		},
		isMinor() {
			return Vue.getValueForKey(this.appointment.patientProperties.entry, 'isMinor');
		},
		timeInStatus() {
			let min = Math.round(this.appointment.timeSpent / 60000);
			let hr = 0;
			let time = '';

			if (min < 0) {
				time = 0 + this.$t('m');
			} else if (min > 99) {
				hr = Math.round(min / 60);
				time = '+' + hr + this.$t('h');
			} else {
				time = min + this.$t('m');
			}
			return time;
		}
	},
	methods: {
		recallAppointment(patientId, appointmentId) {
			Vue.prototype.$frc.recallAppointment(patientId, appointmentId).then(function (res) {
				Vue.notifySuccess({title: i18n.t("patientCalled")});
			}).catch(function (er) {
				console.log(er)
			});
		},
		getOtherAppointments() {
			let app = this;
			app.otherAppointments = [{
				status: app.appointment.checkupStatus,
				consultationGroup: app.appointment.consultationGroup.id
			}];

			if (app.appointment.numOfAppointments > 1) {
				frc.getPatientAppointments(app.appointment.patientId).then(function (res) {
					let appsForPatient = res.data;
					let otherAppointments = [];
					let nextConsultations = [];
					appsForPatient.forEach(function (_app) {
						if (app.isConsultation(_app.appointmentType) && app.isPlanned(_app.checkupStatus)) {
							nextConsultations.push({
								'time': _app.time,
								'physician': _app.physician.name
							})
						} else {
							otherAppointments.push({
								status: _app.checkupStatus,
								consultationGroup: _app.consultationGroup.id
							});
						}
						app.nextConsultation = nextConsultations[0];
					})
					app.otherAppointments = otherAppointments;
				}).catch(function (e) {
					console.log(e);
				});
			}
		},
		appStatus(group) {
			for (let i in this.otherAppointments) {
				let appo = this.otherAppointments[i];
				if (appo.consultationGroup === group.id) {
					if (this.isDone(appo.status)) {
						return 'green-disabled'
					} else {
						return 'green-active'
					}
				}
			}
		},
		canForwardPatient() {
			if (this.isStatusAtWaitingArea(this.appointment.status)) {
				return true;
			}
			let currentCheckup = this.getCurrentCheckup();
			let statusRank = this.appointmentStatus.rank;
			return currentCheckup
					&& statusRank === currentCheckup.rank
					&& this.isStarted(currentCheckup.status);
		},
		getCurrentCheckup() {
			if (!this.appointment) {
				return null;
			}
			let checkups = this.appointment.checkups;
			let checkup;
			for (let i in checkups) {
				checkup = checkups[i];
				if (this.isStarted(checkup.status)) {
					return checkup;
				}
			}
			return checkup;
		},
		onDragStart: function (draggable) {
			EventBus.$emit("dragStarted" + this.plugin, {
				'appointment': this.appointment,
				'status': this.appointmentStatus,
				'draggable': draggable
			});
		},
		dropOnCard: function (sortable, event) {
			if (sortable) {
				EventBus.$emit("droppedOnCard", {
					'event': event,
					'appointment': this.appointment,
					'status': this.appointmentStatus
				});
			}
		},
		forwardPatient: function () {
			EventBus.$emit("forwardPushed" + this.plugin, {
				'appointment': this.appointment,
				'status': this.appointmentStatus
			});
		},
		selectPatient: function (patient) {
			let device = !!this.device;
			EventBus.$emit("patientSelected" + this.plugin, {
				id: patient.patientId,
				name: patient.patientName,
				internalIds: patient.internalIds,
				status: patient.status,
				device: device
			});
		},
      getCalledToRoom() {
          let statusRank = this.appointmentStatus.rank;
          let checkups = this.appointment.checkups;
          for (let i in checkups) {
              let checkup = checkups[i];
              if (checkup.rank === statusRank && checkup.calledTo) {
                  return checkup.calledTo.displayName;
              }
          }
          return '';
      },
	}
}
</script>

<style scoped>
.w3-panel {
	margin-bottom: 0 !important;
}

.group-blocks {
	width: 100%;
	display: flex;
	margin-bottom: 5px;
}

.group-blocks div {
	flex: 1;
	border: 1px solid;
	border-radius: 5px;
	margin-right: 3px;
	padding: 0 3px;
}

.green-active {
	background-color: var(--flow-green-active-color);
	opacity: 1;
	color: white
}

.green-disabled {
	background-color: orange;
	opacity: 0.6;

}
</style>